jQuery(function ($) {
    var $header = $('.it-site-header');
    var $burger = $header.find('.it-site-header__burger');
    var $menu = $header.find('.it-site-header__menu');

    if ($header.length) {
        var toggleScrolledClass = function () {
            $header.toggleClass('is-scrolled', window.scrollY > 0);
        };

        toggleScrolledClass();
        $(window).on('scroll', toggleScrolledClass);
    }

    if (!$burger.length || !$menu.length) {
        return;
    }

    // `100vh`/`100dvh` can't be trusted on mobile: Android Chrome measures
    // vh against the large viewport (the strip behind the URL bar counts),
    // and iOS Safari's floating bottom toolbar overlays the page without
    // shrinking it — either way the drawer's last items end up under the
    // browser chrome with no way to scroll to them. visualViewport reports
    // what is actually on screen right now, so the height is measured from
    // the drawer's own top edge down to that, minus a small bottom gap.
    var setMenuMaxHeight = function () {
        if (!$burger.is(':visible')) {
            $menu.css('max-height', '');
            return;
        }

        var viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
        // Measured off the header, not the drawer: this runs while the
        // drawer is still `display: none` (so its own rect would be all
        // zeros). The 10px matches the `top: calc(100% + 10px)` offset the
        // drawer is positioned at in site-header.scss.
        var menuTop = $header[0].getBoundingClientRect().bottom + 10;

        $menu.css('max-height', Math.max(viewportHeight - menuTop - 16, 200) + 'px');
    };

    $burger.on('click', function () {
        var opening = !$menu.is(':visible');

        setMenuMaxHeight();
        $menu.fadeToggle(200);
        $header.toggleClass('is-menu-open', opening);
        $burger.attr('aria-expanded', opening ? 'true' : 'false');

        // src/js/background-video.js listens for this to pause background
        // videos while the drawer is open — on some Android/Chrome builds a
        // playing video's hardware compositing layer can render above a
        // fixed/absolute element regardless of z-index while scrolling, and
        // a paused video doesn't get that treatment.
        document.dispatchEvent(new CustomEvent('it:mobile-menu-toggle', { detail: { open: opening } }));
    });

    // Re-measured on resize/orientation change, and on the viewport events
    // that fire as mobile browser chrome collapses or expands mid-scroll.
    $(window).on('resize orientationchange', setMenuMaxHeight);

    if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', setMenuMaxHeight);
        window.visualViewport.addEventListener('scroll', setMenuMaxHeight);
    }


    // Tapping/clicking a parent item toggles its submenu instead of
    // navigating — same behavior on desktop and mobile now (desktop used to
    // open on hover; see site-header.scss for the matching CSS switch to
    // `.is-submenu-open`).
    $menu.on('click', '.menu-item-has-children > a', function (e) {
        var $link = $(this);
        var $submenu = $link.siblings('.sub-menu');

        if (!$submenu.length) {
            return;
        }

        e.preventDefault();
        e.stopPropagation();
        $link.trigger('blur');

        var $item = $link.parent();
        var opening = !$item.hasClass('is-submenu-open');

        // Only one submenu open at a time — closing any other before
        // opening (or instead of opening) this one.
        $menu.find('.menu-item-has-children.is-submenu-open').not($item).each(function () {
            $(this).removeClass('is-submenu-open').children('.sub-menu').stop(true, true).fadeOut(200);
        });

        $submenu.stop(true, true);

        if (opening) {
            // Set flex first, then hide/fadeIn: jQuery restores the display
            // it hid *from*, so this brings the submenu back as `flex`
            // rather than the `block` it would default to for a <ul>.
            $submenu.css('display', 'flex').hide().fadeIn(200);
        } else {
            $submenu.fadeOut(200);
        }

        $item.toggleClass('is-submenu-open', opening);
    });

    // Click outside an open submenu closes it (mirrors the language pill
    // below). Harmless on mobile too — it just collapses that accordion
    // item, same as tapping it again would.
    $(document).on('click', function (e) {
        var $openItems = $menu.find('.menu-item-has-children.is-submenu-open');

        if (!$openItems.length) {
            return;
        }

        $openItems.each(function () {
            var $item = $(this);

            if ($item.is(e.target) || $item.has(e.target).length) {
                return;
            }

            $item.removeClass('is-submenu-open').children('.sub-menu').stop(true, true).fadeOut(200);
        });
    });

    // Desktop language pill: click opens the dropdown (hover only widens the
    // pill itself, see site-header.scss) and any click outside closes it —
    // the mobile row rendered alongside it has no toggle, so this only ever
    // targets the one that's actually present in the DOM.
    var $lang = $header.find('.it-site-header__lang');
    var $langToggle = $lang.find('.it-site-header__lang-toggle');

    if ($lang.length) {
        $langToggle.on('click', function (e) {
            e.stopPropagation();
            var opening = !$lang.hasClass('is-open');
            $lang.toggleClass('is-open', opening);
            $langToggle.attr('aria-expanded', opening ? 'true' : 'false');
        });

        $(document).on('click', function (e) {
            if (!$lang.hasClass('is-open') || $lang.is(e.target) || $lang.has(e.target).length) {
                return;
            }

            $lang.removeClass('is-open');
            $langToggle.attr('aria-expanded', 'false');
        });
    }
});
